
import { defineComponent, PropType } from 'vue'
import { IRelatedGlossaryTerms } from '@interfaces/ResourcesTypes'

export default defineComponent({
  name: 'RelatedGlossaryTerms',
  props: {
    terms: {
      type: Array as PropType<IRelatedGlossaryTerms[]>,
      required: true,
    },
  },
})
